import { Shield, Sparkles, Gauge, BarChart3, Handshake, Wrench } from 'lucide-react';
import { VERSION_AREAS, VersionArea } from '../../config/versionAreas';

interface VersionAreaBadgeProps {
  readonly area: VersionArea;
}

const iconMap = {
  Shield,
  Sparkles,
  Gauge,
  BarChart3,
  Handshake,
  Wrench,
};

export function VersionAreaBadge({ area }: VersionAreaBadgeProps) {
  const config = VERSION_AREAS[area];
  if (!config) return null;
  const IconComponent = iconMap[config.icon as keyof typeof iconMap];

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded border bg-transparent ${config.className}`}>
      <IconComponent className="w-3 h-3" />
      {config.label}
    </span>
  );
}
